import styled from "styled-components";

export const HeaderDiv = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
  padding-left: 40px;
  background-color: ${({ theme }) => theme.playerCardBackground};
  border-bottom: 1px solid ${({ theme }) => theme.playerDataBorder};
  color: ${({ theme }) => theme.playerColor};
  font-family: "Aeonik";
  font-size: 64px;
  font-style: normal;
  font-weight: 500;
  line-height: 64px;
  height: 80px;
  & h1 {
    margin-block-end: 0;
    margin-block-start: 0;
  }
`;

export const ChemistryHeader = styled.div`
  background-color: ${({ theme }) => theme.playerCardBackground};
  border-bottom: 1px solid ${({ theme }) => theme.playerDataBorder};
  color: ${({ theme }) => theme.playerColor};
  & button {
    color: ${({ theme }) => theme.playerColor};
  }
`;

export const TopSecondDiv = styled.div`
  display: flex;
  justify-content: center;
  gap: 70px;
  align-items: center;
  background-color: ${({ theme }) => theme.playerCardBackground};
  border-bottom: 1px solid ${({ theme }) => theme.playerDataBorder};
  color: ${({ theme }) => theme.playerColor};
  font-family: "Aeonik";
  font-style: normal;
  height: 100px;
`;

export const SeasonText = styled.p`
  font-size: 22px;
  font-weight: 700;
  display: flex;
  gap: 20px;
  align-items: center;
  font-family: "Aeonik";
`;

export const SeasonNumber = styled.span`
  font-family: "DM Mono";
  font-weight: 500;
  font-size: 16px;
  color: #7c8084;
  margin-bottom: -4px;
`;

export const VisulisationHeader = styled.p`
  font-size: 32px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: left;
  font-family: "Aeonik";
  text-align: center;
  gap: 5px;
  .icon {
    color: ${({ theme }) => theme.NumberColor};
    cursor: pointer;
    margin-bottom: -4px;
  }
`;

export const TeamDrawerHeader = styled.p`
  font-size: 32px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: "Aeonik";
  gap: 5px;
  margin-block-end: 25px;
  .icon {
    color: ${({ theme }) => theme.NumberColor};
  }
`;

export const PitchContainer = styled.div`
  position: absolute;
  max-width: 55%;
  top: 44%;
  padding-bottom: 30px;
  left: 23%;
  @media (min-width: 2000px) {
    top: 32%;
  }
  @media (max-height: 800px) {
    top: 56%;
  }
`;

export const TeamSelectionHeader = styled.div`
  display: flex;
  color: ${({ theme }) => theme.playerColor};
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid ${({ theme }) => theme.playerDataBorder};
  & button {
    color: ${({ theme }) => theme.playerColor};
    border-radius: 20px;
    height: 40px;
    width: 40px;
    margin-top: 10px;
  }
`;

export const TeamButtonContainer = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
  justify-content: right;
  & p:first-child {
    font-family: "DM Mono";
    font-weight: 500;
    font-size: 18px;
    color: ${({ theme }) => theme.NumberColor};
  }
  & button {
    padding: 0px;
    font-family: "Aeonik";
    font-weight: 700;
    font-size: 20px;
    color: ${({ theme }) => theme.playerColor};
    text-transform: none;
    margin-top: -3px;
    & .select-team-label {
      font-family: "Aeonik";
      font-weight: 700;
      font-size: 20px;
      color: #00d1a8;
    }
    & svg {
      margin-bottom: -4px;
      margin-left: -5px;
    }
  }
`;

export const FormationButtonContainer = styled.div`
  display: flex;
  gap: 15px;
  align-items: center;
  & p:first-child {
    font-family: "DM Mono";
    font-weight: 500;
    font-size: 18px;
    color: ${({ theme }) => theme.NumberColor};
  }
  & button {
    padding: 0px;
    font-family: "Aeonik";
    font-weight: 700;
    font-size: 18px;
    color: ${({ theme }) => theme.playerColor};
    text-transform: none;
    margin-top: -3px;
  }
`;

export const TeamSelectionContainer = styled.div`
  // width: 470px;
  background-color: ${({ theme }) => theme.playerContentBackground};
  height: 100vh;
  padding: 30px 30px 0px 30px;
  box-shadow: 8px 0px 16px 0px rgba(0, 0, 0, 0.15);
  overflow: auto;
  -ms-overflow-style: none;
  scrollbar-width: none;
  ::-webkit-scrollbar { 
    display: none;  /* Safari and Chrome */
  }
`;

export const PerfomanceValueContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
  & h4 {
    color: ${({ theme }) => theme.playerColor};
    font-weight: 700;
    font-size: 16px;
    margin-block-end: 0;
    margin-block-start: 0;
    font-family: "Aeonik";
  }
`;

export const TeamFilterContainer = styled.div`
  width: 100%;
  & ul > div {
    max-width: 450px;
    margin-top: 20px;
  }
  & ul > div > label {
    color: ${({ theme }) => theme.playerColor};
    font-weight: 500;
    font-size: 18px;
  }
  & ul > div > div > input {
    font-family: "Aeonik";
    font-weight: 500;
    font-size: 20px;
    color: ${({ theme }) => theme.playerColor};
  }
  & ul > div > div > input::placeholder {
    font-family: "Aeonik";
    font-weight: 500;
    font-size: 20px;
    opacity: 1;
    color: ${({ theme }) => theme.NumberColor};
  }
  & .page-padding {
    position: relative;
    padding-bottom: 20px;
    margin-left: 7px;
    width: 98%;
    & svg {
      width: 32px;
      height: 32px;
    }
  }
  & .page-padding:after {
    content: "";
    display: block;
    width: 94%;
    height: 1px;
    left: 10px;
    bottom: 6px;
    position: absolute;
    border-bottom: 1px solid ${({ theme }) => theme.playerDataBorder};
  }
  & .player-search-data {
    margin-top: 32px;
    margin-bottom: 16px;
  }
  & .player-profile-list {
    padding-top: 0px;
  }
  & .custom-scrollbar {
    // max-height: 600px;
    & li {
      height: 60px;
    }
    & li:hover {
      background: ${({ theme }) => theme.selectedListBackground};
    }
  }
`;

export const TeamListingContainer = styled.div`
  background-color: ${({ theme }) => theme.secondaryButtonBackground};
  border-radius: 5px;
  max-height: 450px;
  padding: 5px;
  padding-top: 15px;
  overflow-y: scroll;
  box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.15);
  &::-webkit-scrollbar-track {
    -webkit-box-shadow: transparent;
    background-color: ${({ theme }) => theme.scrollbarTrack};
    position: fixed;
    top: 0px;
    right: 10px;
    bottom: 0px;
  }

  &::-webkit-scrollbar {
    width: 4px;
    background-color: #f5f5f5;
    position: fixed;
    top: 0px;
    right: 10px;
    bottom: 0px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: ${({ theme }) => theme.scrollbarThumb};
    border-radius: 10px;
    position: fixed;
    top: 0px;
    right: 10px;
    bottom: 0px;
  }

  & ::-webkit-scrollbar {
    display: none;
  }

  & li > div > span {
    color: ${({ theme }) => theme.playerColor};
    font-family: "Aeonik";
    font-weight: 500;
    font-size: 20px;
    line-height: 20px;
  }
  & li > div {
    height: 40px;
    display: flex;
    align-items: center;
  }
`;

export const SwapSimulationContainer = styled.div`
  font-family: "Aeonik";
  & h5 {
    font-family: "Aeonik";
    color: ${({ theme }) => theme.playerColor};
    font-weight: 700;
    font-size: 20px;
  }
  & p:nth-child(2) {
    font-weight: 500;
    font-size: 18px;
    display: flex;
    align-items: center;
    color: ${({ theme }) => theme.NumberColor};
    & svg {
      margin-bottom: -5px;
    }
  }
  & button {
    background-color: #00be99;
    font-family: "Aeonik";
    font-weight: 600;
    font-size: 16px;
    border-radius: 5px;
    border: 0px;
    height: 40px;
    width: 220px;
    line-height: 18px;
    display: flex;
    align-items: center;
    & svg {
      margin-bottom: -5px;
      width: 30px;
      height: 30px;
    }
  };
`;

export const SwapSimilarContainer = styled.div`
  font-family: "Aeonik";
  margin-top: 20px;
  position : relative;
  & ul {
    margin-block-end: 0px;
  };
  & h5 {
    font-family: "Aeonik";
    color: ${({ theme }) => theme.playerColor};
    font-weight: 700;
    font-size: 20px;
  };
  & .otherSquad {
    font-family: "Aeonik";
    font-size: 16px;
    font-weight: 500;
    color: #7C7D79;
    margin-block-end: 0;
    margin-block-start: 0;
  };
  & .player-search-data {
    margin-top: 24px;
    margin-bottom: 0px;
    padding-bottom: 24px;
    border-bottom: 1px solid #DADADA;
  }
`;

export const PlayerDBSearchContainer = styled.div`
  position: absolute;
  top: 0;
  width: 100%;
  height: 100vh;
  background-color: transparent;
  backdrop-filter: blur(16px);
  z-index: 2;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const PlayerFromSamePositionContainer = styled.ul`
  padding-inline-start: 0px;
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 10px;
  // max-height: 25vh;
  padding-bottom: 12px;
  box-sizing: border-box;
  overflow: scroll;
  -ms-overflow-style: none;
  // scrollbar-width: none;
  overflow-x: clip;
  // padding-left: 0px !important;
  // max-width: 100% !important;

  &::-webkit-scrollbar-track {
    //-webkit-box-shadow: transparent;
    background-color: ${({ theme }) => theme.scrollbarTrack};
    // position: fixed;
    // top: 0px;
    // right: 10px;
    // bottom: 0px;
  }

  &::-webkit-scrollbar {
    // width: 4px;
    // background-color: #F5F5F5;
    // position: fixed;
    // top: 0px;
    // right: 10px;
    // bottom: 0px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: ${({ theme }) => theme.scrollbarThumb};
    // border-radius: 10px;
    // position: fixed;
    // top: 0px;
    // right: 10px;
    // bottom: 0px;
  }

  & ::-webkit-scrollbar {
    display: none;
  }

  & img {
    width: 40px;
    height: 40px;
    background-color: #d9d9d9;
    border-radius: 100%;
    margin-left: 8px;
  }
  & li {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border: 1px solid ${({ theme }) => theme.swapSamePositionPlayerBorder};
    border-radius: 5px;
    padding: 5px;
  }
  & li > div {
    display: flex;
    align-items: center;
    gap: 10px;
    & svg {
      margin-bottom: -5px;
    }
  }
  & svg {
    padding: 5px;
    background-color: ${({ theme }) => theme.secondaryButtonBackground};
    border-radius: 5px;
    border: 1px solid ${({ theme }) => theme.secondaryButtonBorderColor};
    cursor: pointer;
  }
  & .playerName {
    font-family: "DM Mono";
    font-size: 18px;
    text-transform: uppercase;
    font-weight: 500;
    color: ${({ theme }) => theme.playerColor};
    @media (max-width: 1200px) {
      font-size: 14px;
    }
  }
  & .minsPlayed {
    font-family: "DM Mono";
    font-size: 12px;
    text-transform: uppercase;
    font-weight: 500;
    color: ${({ theme }) => theme.NumberColor};
    @media (max-width: 1200px) {
      font-size: 10px;
    }
  }

  & .player-data:hover {
    background-color: ${({ theme }) => theme.playerCardBorderColor};
  }

  & .player-data.selected {
    background-color: ${({ theme }) => theme.playerCardBorderColor};
  }
`;

export const BookmarkButton = styled.button`
  max-width: max-content;
  height: 45px;
  display: flex;
  border-radius: 5px;
  border: 1px solid ${({ theme }) => theme.secondaryButtonBorderColor};
  color: ${({ theme }) => theme.playerColor};
  align-items: center;
  gap: 5px;
  padding: 0px 10px;
  background-color: ${({ theme }) => theme.secondaryButtonBackground};
  justify-self: end;
  margin-right: 60px;
  font-family: "Aeonik";
  font-weight: 600;
  line-height: 18px;
  font-size: 15px;
  & svg {
    width: 25px;
    height: 25px;
  }
`;

export const BackToTeamChemistryBtn = styled.button`
  display: flex;
  align-items: center;
  height: 50px;
  width: max-content;
  padding: 5px 12px;
  border-radius: 100px;
  font-family: "Aeonik";
  font-weight: 500;
  font-size: 15px;
  position: relative;
  color: ${({ theme }) => theme.playerColor};
  background-color: ${({ theme }) => theme.thumbBackground};
  border: 1px solid ${({ theme }) => theme.playerDataBorder};
  // @media (max-width: 1200px) {
  //   right: 130px;
  // }
  // @media (max-width: 1200px) {
  //   right: 0px;
  // }
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
  & img {
    margin-right: 5px;
    width: 24px;
    height: 24px;
    filter: ${({ theme }) => (theme.PitchColor === "#1B1B1B" ? "grayscale(100%) brightness(0) invert(1)" : "none")};
  }
`;

// export const MatchTrackContainer = styled.div`
//   padding: 20px 0px;
//   width: 100%;
//   display: flex;
//   margin-top: 30px;
//   justify-content: center;
//   & > div {
//     border-bottom: 6px solid #18b686;
//     width: 95%;
//   }
//   & .team-logo-main {
//     height: 80px;
//   }
//   & .team-logo-main:before {
//     height: 1px;
//     background: ${({ theme }) => theme.playerCardBorderColor};
//   }
//   & .team-logo-main:after {
//     width: 1px;
//     top: 55%;
//     background: ${({ theme }) => theme.playerCardBorderColor};
//   }
//   & .team-logos-wrapper:before {
//     width: 1px;
//     top: 55%;
//     background: ${({ theme }) => theme.playerCardBorderColor};
//   }
//   & .team-logos-wrapper:nth-of-type(1):before {
//     height: 80px;
//     top: 105%;
//     width: 1px;
//   }
//   & .team-logos-wrapper {
//     & span {
//       color: ${({ theme }) => theme.matchLabel};
//     }
//   }
// `;

export const TimelineLowerButtonContainer = styled.div`
  display: flex;
  gap: 5px;
  width: 95%;
  justify-content: end;
  & button {
    height: 34px;
    width: 34px;
    border-radius: 5px;
    border: 1px solid ${({ theme }) => theme.secondaryButtonBorderColor};
    background-color: ${({ theme }) => theme.selectedListBackground};
    cursor: not-allowed;
    & svg {
      opacity: 0.5;
      margin-bottom: -2px;
      margin-left: -2px;
      filter: ${({ theme }) => theme.PitchColor === "#1B1B1B" && "grayscale(100%) invert(100%)"};
    }
  }
`;

export const MatchTimelineParent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
  & .left-arrow-btn {
    height: 52px;
    width: 34px;
    border-radius: 5px;
    position: absolute;
    left: 1.7%;
    bottom: 74px;
    z-index: 2;
    border: 1px solid ${({ theme }) => theme.secondaryButtonBorderColor};
    background-color: ${({ theme }) => theme.selectedListBackground};
    cursor: not-allowed;
    & svg {
      height: 30px;
      width: 30px;
      margin-bottom: -2px;
      margin-left: -6px;
      filter: ${({ theme }) => theme.PitchColor === "#1B1B1B" && "grayscale(100%) invert(100%)"};
    }
  }
  & .play-bottom-btn {
    width: 34px;
    height: 34px;
    position: absolute;
    z-index: 2;
    border: 1px solid ${({ theme }) => theme.secondaryButtonBorderColor};
    background-color: ${({ theme }) => theme.selectedListBackground};
    cursor: not-allowed;
    border-radius: 5px;
    left: 1.7%;
    bottom: 0;
    & svg {
      margin-bottom: -2px;
      margin-left: -2px;
      filter: ${({ theme }) => theme.PitchColor === "#1B1B1B" && "grayscale(100%) invert(100%)"};
    }
  }
`;

export const PlayerCardContainer = styled.div`
  z-index: 3;
  height: max-content;
  // @media (min-width: 2000px) {
  //  top: 20%;
  //  height: 60%;
  // };
  width: 320px;
  border: 1px solid black;
  position: absolute;
  top: 20px;
  right: 20px;
  border-radius: 10px;
  padding: 22px 5px;
  border: 1px solid ${({ theme }) => theme.tabBorderColor};
  background-color: ${({ theme }) => theme.playerContentBackground};
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 5px;
  @media (max-width: 1366px) {
    width: 300px;
    //
  }
  @media (max-width: 1366px) {
    width: 300px;
  }

  @media (min-width: 2000px) {
    gap: 12px;
  }
  & .close-btn {
    position: absolute;
    left: 12px;
    width: 30px;
    height: 30px;
    cursor: pointer;
  }
  & .image-container {
    background-color: #d9d9d9;
    border: 1px solid #c2c2c2;
    border-radius: 50%;
    width: 100px;
    height: 100px;
    margin-bottom: -14px;
    @media (min-width: 2000px) {
      width: 140px;
      height: 140px;
    }
    overflow: hidden;
    & img {
      width: 100%;
      margin-bottom: -8px;
    }
  }
  & .name-container {
    width: 90%;
    font-family: "Aeonik";
    font-weight: 700;
    font-size: 18px;
    @media (min-width: 2000px) {
      font-size: 24px;
    }
    & p {
      margin-block-end: 10px;
      margin-block-start: 10px;
    }
    & h3 {
      margin-block-start: 0;
      margin-block-end: 0;
      font-size: 24px;
      @media (min-width: 2000px) {
        font-size: 36px;
        line-height: 40px;
      }
    }
  }
  & .btn-container {
    width: 90%;
    display: flex;
    justify-content: space-between;
    margin-top: 18px;
    & button {
      padding: 7px 5px;
      border-radius: 5px;
      border: 1px solid ${({ theme }) => theme.secondaryButtonBorderColor};
      background-color: ${({ theme }) => theme.secondaryButtonBackground};
      & svg {
        width: 30px;
        margin-bottom: -3px;
        filter: ${({ theme }) => theme.PitchColor === "#1B1B1B" && "grayscale(100%) invert(100%)"};
      }
    }
    & > button {
      display: flex;
      align-items: center;
      gap: 6px;
      padding-right: 12px;
      font-family: "Aeonik";
      font-weight: 700;
      font-size: 16px;
      color: ${({ theme }) => theme.playerColor};
      & svg {
        color: black;
        filter: ${({ theme }) => theme.PitchColor === "#1B1B1B" && "grayscale(100%) invert(100%)"};
      }
    }
    & button:last-child {
      // margin-left: 10px;
    }
    & .bookmark {
      cursor: not-allowed;
    }
    & .share {
      cursor: not-allowed;
    }
  }
  & ul {
    list-style: none;
    width: 90%;
    padding-inline-start: 0;
    & li {
      width: 100%;
      display: flex;
      justify-content: space-between;
      text-transform: uppercase;
      font-family: "DM Mono";
      font-weight: 500;
      font-size: 13px;
      @media (min-width: 2000px) {
        font-size: 15px;
      }
      border-top: 1px solid ${({ theme }) => theme.playerDataBorder};
      & p:first-child {
        margin-block-start: 10px;
        margin-block-end: 10px;
        color: ${({ theme }) => theme.NumberColor};
      }
      & p:nth-of-type(2) {
        margin-block-start: 10px;
        margin-block-end: 10px;
        color: ${({ theme }) => theme.playerColor};
        font-size: 14px;
        @media (min-width: 2000px) {
          font-size: 16px;
        }
      }
    }
    & li:last-child {
      border-bottom: 1px solid ${({ theme }) => theme.playerDataBorder};
    }
  }
  & .bottom-container {
    width: 90%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    & div {
      display: flex;
      gap: 4px;
      align-items: center;
    }
    & button {
      cursor: not-allowed;
      height: 40px;
      display: flex;
      align-items: center;
      padding: 0px 15px;
      padding-right: 18px;
      border-radius: 5px;
      border: 1px solid ${({ theme }) => theme.secondaryButtonBorderColor};
      background-color: ${({ theme }) => theme.secondaryButtonBackground};
      font-family: "Aeonik";
      font-weight: 700;
      font-size: 16px;
      gap: 5px;
      color: ${({ theme }) => theme.playerColor};
      & svg {
        color: black;
        width: 30px;
        height: 30px;
        filter: ${({ theme }) => theme.PitchColor === "#1B1B1B" && "grayscale(100%) invert(100%)"};
      }
    }
    & p {
      font-family: "Aeonik";
      font-weight: 700;
      font-size: 16px;
      color: ${({ theme }) => theme.playerColor};
      margin-block-start: 0px;
      margin-block-end: 0px;
    }
    & span {
      cursor: not-allowed;
    }
  }
`;

export const SideBtnContainer = styled.div`
  border: 1px solid ${({ theme }) => theme.filterdropdownBorder};
  background-color: ${({ theme }) => theme.selectedListBackground};
  & button {
    color: ${({ theme }) => theme.playerColor};
    margin: 2px;
  }
  & .active-layer-icon {
    background-color: #00d1a8;
    & .secondary-cta-icon {
      filter: none;
    }
  }
`;

export const MatchTimeLineWrapper = styled.div<{ isTeamSelected: boolean }>`
  &:before {
    background: ${({ isTeamSelected, theme }) => (isTeamSelected ? "#18b686" : theme.timeline)};
  }
`;

export const MatchTrackContainer = styled.div`
  &:before {
    background: ${({ theme }) => theme.playerCardBorderColor};
  }
  &:after {
    background: ${({ theme }) => theme.playerCardBorderColor};
  }
`;

export const IndividualStatContainer = styled.div`
  & div {
    background-color: ${({ theme }) => theme.selectedListBackground};
    border: 1px solid ${({ theme }) => theme.playerDataBorder};
    color: ${({ theme }) => theme.NumberColor};
    & span {
      color: ${({ theme }) => theme.playerColor};
    }
  }
`;

export const VisNameContainer = styled.div<{ isSelected: boolean }>`
  border: 0;
  border-left: 0px;
  border-radius: 0px;
  border-right: 1px solid ${({ theme }) => theme.secondaryButtonBorderColor};
  background: ${({ isSelected, theme }) => (isSelected ? "var(--Brand-green-1-500, #00D1A8)" : theme.secondaryButtonBackground)};
  color: ${({ isSelected, theme }) => (isSelected ? "var(--Brand-black-500, #111)" : theme.playerColor)};
  & svg {
    height: 20px;
    width: 20px;
  }
`;

export const PWBtnContainer = styled.div<{ isSelected: boolean }>`
  &:hover {
    & .vis-name {
      color: ${({ isSelected, theme }) => (isSelected ? "var(--Brand-black-500, #111)" : theme.playerColor)};
      background: ${({ isSelected, theme }) => (isSelected ? "var(--Brand-green-1-500, #00D1A8)" : theme.secondaryButtonBorderColor)};
    }
    & .sidebar-btn {
      background: ${({ isSelected, theme }) => (isSelected ? "var(--Brand-green-1-500, #00D1A8)" : theme.secondaryButtonBorderColor)};
      & img {
        filter: ${({ isSelected, theme }) =>
          isSelected ? "none" : theme.playerColor === "var(--Brand-white-500, #FFF)" ? "grayscale(100%) brightness(0) invert(1)" : "none"};
      }
    }
  }
`;

export const FullViewContainer = styled.div`
  position: relative;
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  & #large-pitch-container {
    width: 55%;
  }
`;

export const SummaryBarContainer = styled.div`
  background-color: ${({ theme }) => theme.playerCardBackground};
  border-top: 1px solid ${({ theme }) => theme.borderColor};
`;

export const VisibilityContainer = styled.div`
  border: 1px solid ${({ theme }) => theme.playerCardBorderColor};
`;

export const SummaryOpenContainer = styled.div`
  border: 1px solid ${({ theme }) => theme.playerDataBorder};
  background-color: ${({ theme }) => theme.summarybarOpenColor};
  & div {
    border: 1px solid ${({ theme }) => theme.playerCardBorderColor};
  }
`;

export const ToooltipSummaryBar = styled.p`
  background-color: ${({ theme }) => theme.secondaryButtonBackground};
  &:after {
    content: " ";
    position: absolute;
    top: 100%; /* At the bottom of the tooltip */
    left: 50%;
    margin-left: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: ${({ theme }) => theme.secondaryButtonBackground} transparent transparent transparent;
  }
`;
